module.exports = require("./gsw-CH");